import { Badge } from './badge';
import { Button } from './button';
import { Card, CardContent, CardFooter } from './card';
import { KindIcon } from './kind-icon';

interface MarketplaceCardProps {
  artifactId: string;
  slug: string;
  kind: string;
  description?: string;
  visibility?: string;
  version?: string;
  offerType?: string | null;
  offerTitle?: string | null;
  onAcceptOffer?: () => void;
  onImport?: () => void;
  showActions?: boolean;
}

const KIND_BADGE_CLASS: Record<string, string> = {
  agent: 'bg-blue-50 text-blue-700 border-blue-200',
  hive: 'bg-purple-50 text-purple-700 border-purple-200',
  collection: 'bg-green-50 text-green-700 border-green-200',
  skill: 'bg-amber-50 text-amber-700 border-amber-200',
};

export function MarketplaceCard({
  slug,
  kind,
  description,
  visibility,
  version,
  offerType,
  offerTitle,
  onAcceptOffer,
  onImport,
  showActions = true,
}: MarketplaceCardProps) {
  return (
    <Card
      className="flex flex-col hover:shadow-md transition-shadow"
      data-testid="cac-catalog-item"
    >
      <CardContent className="flex-1 p-4 space-y-3">
        <div className="flex items-start gap-3">
          <KindIcon kind={kind} size={28} className="text-muted-foreground shrink-0 mt-0.5" />
          <div className="min-w-0 flex-1">
            <h3 className="font-semibold text-sm truncate">{slug}</h3>
            {description ? (
              <p className="text-xs text-muted-foreground line-clamp-2 mt-0.5">{description}</p>
            ) : null}
          </div>
        </div>
        <div className="flex flex-wrap gap-1.5">
          <Badge variant="outline" className={KIND_BADGE_CLASS[kind] ?? ''}>
            {kind}
          </Badge>
          {visibility ? (
            <Badge variant="outline" className="text-xs">
              {visibility}
            </Badge>
          ) : null}
          {version ? (
            <Badge variant="outline" className="text-xs font-mono">
              v{version}
            </Badge>
          ) : null}
          {offerTitle ? (
            <Badge
              variant={offerType === 'free' ? 'secondary' : 'destructive'}
              className="text-xs"
            >
              {offerTitle}
            </Badge>
          ) : null}
        </div>
      </CardContent>
      {showActions ? (
        <CardFooter className="p-4 pt-0 flex justify-end gap-2">
          {onAcceptOffer ? (
            <Button variant="outline" size="sm" onClick={onAcceptOffer}>
              Accept
            </Button>
          ) : null}
          {onImport ? (
            <Button variant="default" size="sm" onClick={onImport}>
              Import
            </Button>
          ) : null}
        </CardFooter>
      ) : null}
    </Card>
  );
}
